<div class="descriptions-container">
  <!-- Pro -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Pro"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.PRO.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.PRO.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div
      class="feature-description-container__three margined flex flex-row gap-[24px] lt-md:!hidden"
    >
      <div>
        <h4>{{ '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </div>
    </div>
    <div class="lt-md:!hidden">
      <h2>{{ '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate }}</h2>
    </div>
    <div
      class="feature-description-container__three margined flex flex-row gap-[24px] lt-md:!hidden"
    >
      <div>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartOne"
        ></app-translate-list>
      </div>
      <div>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartTwo"
        ></app-translate-list>
      </div>
      <div>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartThree"
        ></app-translate-list>
      </div>
    </div>

    <div class="feature-description-container__four spacer flex flex-row gap-[24px] lt-md:!hidden">
      <div>
        <h4>{{ '+FLAT_BOOKING.PLAN.PRO.SPEC.PARAMETERS.TITLE' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.parameterDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.PARAMETER_COMPARISON' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.parameterComparisonDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.DATA_LOGGING' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.dataLoggingDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.systemOverviewDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate }}</h4>
        </mat-expansion-panel-header>
        <div class="flex flex-col">
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartOne"
            ></app-translate-list>
          </div>
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartTwo"
            ></app-translate-list>
          </div>
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="commercialBookingPlansSpecification.includedFunctionsDetails_PartThree"
            ></app-translate-list>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <span class="divider"></span>
  <!-- Basic -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        class="booking-badge"
        [packageType]="subscriptionsPlanType.Basic"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+COMMERCIAL_BOOKING.PLAN.BASIC.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+COMMERCIAL_BOOKING.PLAN.BASIC.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container__three flex flex-row gap-[24px] lt-md:!hidden">
      <div>
        <h4>{{ '+COMMERCIAL_BOOKING.PLAN.BASIC.FEATURE.INVITATIONS_TITLE' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.invitationsDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+COMMERCIAL_BOOKING.PLAN.BASIC.FEATURE.INVITATIONS_TITLE' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.invitationsDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <span class="divider"></span>
  <!-- Free -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        class="booking-badge"
        [packageType]="subscriptionsPlanType.Free"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+COMMERCIAL_BOOKING.PLAN.FREE.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+COMMERCIAL_BOOKING.PLAN.FREE.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container__two flex flex-row gap-[24px] lt-md:!hidden">
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </div>
      <div>
        <h4>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</h4>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="commercialBookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <span class="divider"></span>
  <div class="references flex flex-col gap-[16px]">
    <p>{{ '+COMMERCIAL_BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE' | translate }}</p>
    <p>{{ '+COMMERCIAL_BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE_SECOND' | translate }}</p>
  </div>
</div>
